/**
 * Sub-Customers API Types — Zod Schemas & DTOs
 */

import { z } from '@spcc/core'

export const subCustomerDtoSchema = z.object({
  id: z.union([z.string(), z.number()]).transform(String),
  documentId: z.string(),
  code: z.string(),
  name: z.string(),
  phone: z.string().nullable().optional(),
  customerType: z.enum(['regular', 'placeholder']).nullish().transform((v) => v ?? 'regular'),
  tenant: z
    .object({
      id: z.union([z.string(), z.number()]).transform(String).optional(),
      documentId: z.string().optional(),
      name: z.string(),
      code: z.string().optional().default(''),
    })
    .optional()
    .nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type SubCustomerDto = z.infer<typeof subCustomerDtoSchema>

export const createSubCustomerRequestSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  phone: z.string().optional(),
  customerType: z.enum(['regular', 'placeholder']).optional(),
  tenant: z.string().optional(),
})

export const updateSubCustomerRequestSchema = z.object({
  name: z.string().min(1).optional(),
  phone: z.string().optional().nullable(),
  customerType: z.enum(['regular', 'placeholder']).optional(),
})

export type CreateSubCustomerRequestDto = z.infer<typeof createSubCustomerRequestSchema>
export type UpdateSubCustomerRequestDto = z.infer<typeof updateSubCustomerRequestSchema>

export function validateSubCustomerDto(data: unknown): SubCustomerDto {
  return subCustomerDtoSchema.parse(data)
}
